import React, { Fragment } from 'react';

import { FormFlex, FormBox, FormGroupLoader } from 'components/shared/form';

function Loader() {
  return (
    <Fragment>
      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="21rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="31.25rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="24.75rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="21rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={[1, 1, 1 / 2]}>
          <FormGroupLoader labelWidth="8rem" />
        </FormBox>
        <FormBox width={[1, 1, 1 / 2]}>
          <FormGroupLoader labelWidth="23.75rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="35rem" />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

export default Loader;
